import { InteractionTypes } from '@/entities/interaction';
import { InteractionList } from '@/widgets/interaction-list';

export default function TrustSentPage() {
  return (
    <InteractionList
      type={InteractionTypes.TRUST_REQUESTED}
      direction="sent"
      title="Demandes de contact envoyées"
      emptyMessage="Vous n'avez envoyé aucune demande de contact pour le moment."
    />
  );
}
